export const SECTION_LABELS = {
  purpose: "Purpose",
  scope: "Scope",
  definitions: "Definitions",
  policy_statement: "Policy Statement",
  roles_responsibilities: "Roles & Responsibilities",
  procedure: "Procedure",
  recording: "Recording Requirements",
  escalation: "Escalation",
  related_documents: "Related Documents",
  training: "Training",
  monitoring: "Monitoring",
  review: "Review",
};

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-600 border-transparent",
  under_review: "bg-blue-50 text-blue-700 border-transparent",
  awaiting_approval: "bg-amber-50 text-amber-700 border-transparent",
  approved: "bg-cyan-50 text-cyan-700 border-transparent",
  published: "bg-ukgreen-light text-ukgreen border-transparent",
  superseded: "bg-slate-100 text-slate-500 border-transparent",
  archived: "bg-slate-100 text-slate-400 border-transparent",
  withdrawn: "bg-red-50 text-red-600 border-transparent",
};

export const STATUS_LABELS = {
  draft: "Draft",
  under_review: "Under review",
  awaiting_approval: "Awaiting approval",
  approved: "Approved",
  published: "Published",
  superseded: "Superseded",
  archived: "Archived",
  withdrawn: "Withdrawn",
};

export const ACK_LABELS = {
  none: "No new acknowledgement required",
  all_applicable: "All applicable staff must acknowledge",
  selected_roles: "Selected roles must acknowledge",
  with_knowledge_check: "Acknowledgement + knowledge check required",
  urgent: "URGENT acknowledgement required",
};
